import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxControlPointPattern } from "./dx-control-point-pattern";
import { DxGridRow } from "../../../dx-grid/domain/dx-grid-row";
import 'moment-duration-format';
let DxControlPointInstance = class DxControlPointInstance extends DxGridRow {
    getRowId() {
        return this.id;
    }
};
tslib_1.__decorate([
    jsonMember({ constructor: Date, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], DxControlPointInstance.prototype, "actualPassageDate", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointInstance.prototype, "chainInstanceId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], DxControlPointInstance.prototype, "code", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointInstance.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], DxControlPointInstance.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: DxControlPointPattern, isRequired: true }),
    tslib_1.__metadata("design:type", DxControlPointPattern)
], DxControlPointInstance.prototype, "pattern", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, isRequired: true }),
    tslib_1.__metadata("design:type", Date)
], DxControlPointInstance.prototype, "plannedPassageDate", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], DxControlPointInstance.prototype, "responsibleEmail", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointInstance.prototype, "responsibleId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxControlPointInstance.prototype, "responsibleLogin", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxControlPointInstance.prototype, "responsibleName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxControlPointInstance.prototype, "responsiblePosition", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointInstance.prototype, "timeFlowOrd", void 0);
DxControlPointInstance = tslib_1.__decorate([
    jsonObject()
], DxControlPointInstance);
export { DxControlPointInstance };
